(() => {
  'use strict';
  if (window.AWMonAtelierPostPurchasePriorityP1?.version) return;

  const VERSION = '1.0.0';
  const ROOT_SELECTOR = '[data-aw-atelier]';
  const PURCHASE_PANEL_SELECTOR = '[data-aw-atelier-panel="recommendations"]';
  const PURCHASE_TAB_SELECTOR = '[data-aw-atelier-tab="recommendations"]';
  const EMPTY_GARAGE_TEXT = /aucune\s+r[eé]plique\s+garage\s+active/i;

  const atelierRoot = () => document.querySelector(ROOT_SELECTOR);

  const activatePurchases = () => {
    const root = atelierRoot();
    if (!root) return false;
    const button = root.querySelector(PURCHASE_TAB_SELECTOR);
    const panel = root.querySelector(PURCHASE_PANEL_SELECTOR);
    if (!button || !panel) return false;
    panel.id = 'aw-achats-suivi';
    root.querySelectorAll('[data-aw-atelier-tab]').forEach((tab) => {
      const active = tab === button;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-aw-atelier-panel]').forEach((candidate) => {
      candidate.hidden = candidate !== panel;
    });
    root.dataset.awPostpurchaseActivated = 'true';
    return true;
  };

  const normalizeMainNav = () => {
    document.querySelectorAll('.aw14-nav a[href]').forEach((link) => {
      try {
        const url = new URL(link.getAttribute('href') || '', location.origin);
        if (url.pathname !== '/pages/mon-atelier-airsoft') return;
        if (link.textContent.trim() !== 'Mon Atelier') link.textContent = 'Mon Atelier';
        const nextHref = '/pages/mon-atelier-airsoft';
        if (link.getAttribute('href') !== nextHref) link.setAttribute('href', nextHref);
      } catch (_) {}
    });
  };

  const setEmptyGarageVisibility = () => {
    const root = atelierRoot();
    if (!root) return;
    const candidates = [
      ...document.querySelectorAll('[data-aw-ecosystem-context]'),
      ...root.querySelectorAll('[data-aw-ecosystem-mon-atelier-status]')
    ];
    candidates.forEach((node) => {
      const title = node.querySelector('.aw-ecosystem-p1-context__title')?.textContent || node.textContent || '';
      const obsolete = EMPTY_GARAGE_TEXT.test(title);
      node.hidden = obsolete;
      if (obsolete) node.dataset.awPostpurchaseGarageOptional = 'true';
      else delete node.dataset.awPostpurchaseGarageOptional;
    });
  };

  const ensurePurchaseTarget = () => {
    const root = atelierRoot();
    const panel = root?.querySelector(PURCHASE_PANEL_SELECTOR);
    if (!panel) return;
    panel.id = 'aw-achats-suivi';
    root.dataset.awPostpurchasePriority = VERSION;
  };

  const run = () => {
    const root = atelierRoot();
    if (!root) return;
    ensurePurchaseTarget();
    normalizeMainNav();
    setEmptyGarageVisibility();
    if (location.hash === '#aw-achats-suivi') activatePurchases();
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  };

  window.addEventListener('hashchange', () => {
    if (location.hash === '#aw-achats-suivi') activatePurchases();
    schedule();
  });
  ['aw:garage-context-changed', 'aw:p2-garage-updated', 'aw:context-changed', 'aw:model-index-ready'].forEach((name) => {
    window.addEventListener(name, schedule);
  });
  window.addEventListener('storage', (event) => {
    if (['aw_garage_active_replica_v1', 'aw_garage_replicas_v1'].includes(event.key)) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);

  if ('MutationObserver' in window) {
    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes?.length || mutation.type === 'characterData')) schedule();
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  window.AWMonAtelierPostPurchasePriorityP1 = {
    version: VERSION,
    run,
    activatePurchases,
    policy: 'shopify-order-first;garage-optional;exact-model-only-when-documented'
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  [80, 250, 800, 1800].forEach((delay) => window.setTimeout(run, delay));
})();
